<template>
  <div class="user-actions">

    <div>
      <div class="noted-text tcenter">Show first:</div>
      <label class="cards-switch">
        <input
          id="cards_switcher"
          ref="cardsSwitcher"
          type="checkbox"
          @change="onChooseSide()">
        <span class="slider round"></span>
        <span class='front'></span>
        <span class='back'></span>
      </label>
    </div>

    <a
      href="javascript:void(0);"
      :class="{'shuffle-on' : shuffle}"
      class="shuffle-button"
      @click="onShuffleSelect()"><div>Shuffle</div></a>


  </div>
</template>

<script>

export default {
  data() {
    return {
      frontFirst: true,
      shuffle: false
    }
  },

  methods: {
    onChooseSide(event) {
      if(this.$refs.cardsSwitcher.checked) {
        // back side
        this.frontFirst = false
      } else {
        // front
        this.frontFirst = true
      }
      this.$emit('selectSide', { frontSide: this.frontFirst })
    },

    onShuffleSelect() {
      this.shuffle = !this.shuffle
      this.$emit('shuffle', { shuffle: this.shuffle })
    }
  }
}
</script>
